import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-branches',
  templateUrl: './branches.component.html',
  styleUrls: ['./branches.component.css']
})
export class BranchesComponent {

  constructor(private route: ActivatedRoute, private router: Router)
    {

           
      this.route.params.subscribe((params: any) => {
        this.router.navigate(['/dashboards/dashboard1']);
    });
     
    }

}
